/* eslint-disable no-undef */

export function getBrowserType() {
  const ua = navigator.userAgent.toLowerCase();
  const test = (regex) => regex.test(ua);

  if (test(/opr\//) || window.opr) return 'Opera';
  if (test(/edg/)) return 'Microsoft Edge';
  if (test(/chrome|chromium|crios/)) return 'Google Chrome';
  if (test(/firefox|fxios/)) return 'Mozilla Firefox';
  if (test(/safari/) && !test(/chrome|chromium|crios/)) return 'Apple Safari';
  if (test(/trident/)) return 'Microsoft Internet Explorer';
  if (test(/ucbrowser/)) return 'UC Browser';
  if (test(/samsungbrowser/)) return 'Samsung Browser';

  return 'Unknown browser';
}
